import { render, staticRenderFns } from "./TreemapCharts.vue?vue&type=template&id=8bf7c114&scoped=true&"
import script from "./TreemapCharts.vue?vue&type=script&lang=js&"
export * from "./TreemapCharts.vue?vue&type=script&lang=js&"
import style0 from "./TreemapCharts.vue?vue&type=style&index=0&id=8bf7c114&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf7c114",
  null
  
)

export default component.exports